/* ============================================================
   BROKEN HEARTS — THE CIRCLE
   Popup a due tempi. Vanilla, defer, nessuna libreria.

   Step 1: form nativo Shopify (customer), invio NATIVO: l'antispam del
           negozio vuole un token captcha che solo lo script di Shopify sa
           mettere (una fetch riceve 400 Missing CAPTCHA token). La pagina
           torna su return_to con customer_posted=true e il popup riapre
           direttamente al tempo successivo.
   Step 2: Klaviyo Client API, SOLO chiave pubblica, lista dedicata,
           consenso del canale di messaggistica separato dall'email.
           Nessuna chiave privata esiste in questo file.

   Mostrato una volta: cookie (durata dall'editor) con specchio in
   localStorage. Mai all'apertura: dopo N secondi o al 40% di scroll, e mai sopra il banner
   del consenso (l'attesa e il suo tetto stanno in open()),
   il primo dei due, e comunque mai prima di tre secondi.

   Le tavole (owner 20-10-2026): gli still life approvati in dissolvenza incrociata.
   Nel markup stanno solo in data-src: a pagina fredda NESSUNA richiesta. Le prime due si
   scaricano 3,5 s PRIMA che il popup si apra (preload(): dal timer d'apertura, dallo scroll,
   o appena il banner del consenso se ne va) e il popup non si apre mai su un pannello nero
   (open() aspetta la prima, al massimo 2 s). All'apertura la prima c'e' gia' e si vede subito;
   primo cambio dopo 3,5 s, poi uno ogni 5 s, dissolvenza 1,2 s (CSS); ogni tavola successiva
   si scarica un passo prima. Riduci movimento = una sola tavola, ferma.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('bhCircle');
  if (!root) return;

  var COOKIE = 'bh_circle';
  var DAYS = parseInt(root.getAttribute('data-days'), 10) || 30;
  var DELAY = Math.max(3, parseInt(root.getAttribute('data-delay'), 10) || 8) * 1000;
  var SCROLL = (parseInt(root.getAttribute('data-scroll'), 10) || 40) / 100;
  var COMPANY = root.getAttribute('data-company') || '';
  var LIST_WA = root.getAttribute('data-list-wa') || '';
  var CHANNEL = root.getAttribute('data-channel') === 'sms' ? 'sms' : 'whatsapp';
  /* lo step 2 si accende dall'editor solo quando il canale e' attivo in Klaviyo:
     prima di allora un consenso che l'account non sa registrare sarebbe una
     promessa falsa, e il visitatore vedrebbe un errore non suo */
  var S2 = root.getAttribute('data-s2') === '1';
  var MSG = {
    email: root.getAttribute('data-err-email') || 'Enter a valid email.',
    phone: root.getAttribute('data-err-phone') || 'Enter a valid number.',
    net: root.getAttribute('data-err-net') || 'Something did not go through. Try again.'
  };
  var CONSENT_TEXT = root.getAttribute('data-consent-text') || '';
  /* attesa del banner cookie: vedi open() */
  var CC_STEP = 1200;        /* ogni quanto si ricontrolla */
  var CC_WAIT_MAX = 90000;   /* oltre, per questa pagina si rinuncia */
  var CC_BEAT = 3000;        /* respiro fra il consenso dato e l'apertura */
  var ccDeadline = 0, ccTimer = null, ccWasBlocked = false, ccBeatDone = false;
  var REDUCED = false;
  try { REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------- memoria: cookie prima, localStorage come specchio ---------- */
  function readCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function remember(v) {
    try {
      document.cookie = COOKIE + '=' + encodeURIComponent(v) + '; max-age=' + (DAYS * 86400) + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) {}
    try { localStorage.setItem(COOKIE, v + ':' + Date.now()); } catch (e) {}
  }
  function suppressed() {
    if (readCookie()) return true;
    try {
      var v = localStorage.getItem(COOKIE);
      if (v) {
        var t = parseInt(v.split(':')[1] || '0', 10);
        if (t && Date.now() - t < DAYS * 86400000) return true;
      }
    } catch (e) {}
    return false;
  }

  /* ---------- nodi ---------- */
  var panel = root.querySelector('[data-bhc-panel]');
  var steps = {
    1: root.querySelector('[data-bhc-step="1"]'),
    2: root.querySelector('[data-bhc-step="2"]'),
    3: root.querySelector('[data-bhc-step="3"]')
  };
  var count = root.querySelector('[data-bhc-count]');
  var form1 = root.querySelector('[data-bhc-form]');
  var email = root.querySelector('[data-bhc-email]');
  var err1 = root.querySelector('[data-bhc-err1]');
  var btn1 = root.querySelector('[data-bhc-submit1]');
  var form2 = root.querySelector('[data-bhc-form2]');
  var cc = root.querySelector('[data-bhc-cc]');
  var phone = root.querySelector('[data-bhc-phone]');
  var bdayD = root.querySelector('[data-bhc-bday-d]');
  var bdayM = root.querySelector('[data-bhc-bday-m]');
  var err2 = root.querySelector('[data-bhc-err2]');
  var btn2 = root.querySelector('[data-bhc-submit2]');
  var pics = root.querySelectorAll('[data-bhc-pic]');
  var media = root.querySelector('.bhc__media');
  if (media) media.classList.add('is-js');

  var opened = false, closing = false, current = 1, lastFocus = null;

  /* Cio' che ha la precedenza sul popup: il banner del consenso (lo chiede all'orchestratore) e le soglie a tutto
     schermo, il velo nero dei capitoli (html.bh-cds-on, 20-10-2026) e l'ingresso AUREUM (html.bh-aud-on). Finche'
     una delle due c'e' il popup non parte e non precarica: aspetta, come col banner. */
  function layerBlocking() {
    var g = window.BHLayers && window.BHLayers.cookieBlocking;
    if (g && g()) return true;
    var c = document.documentElement.classList;
    // 26-10-2026: neanche mentre il cliente scrive nella ricerca (bhs-open): il popup gli rubava il fuoco e i tasti
    // finivano nel campo email.
    return c.contains('bh-cds-on') || c.contains('bh-aud-on') || c.contains('bhs-open');
  }

  /* ---------- apertura ---------- */
  function lockScroll(on) {
    if (on) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
    }
  }

  function open(atStep) {
    if (opened) return;

    /* MAI SOPRA IL BANNER DEI COOKIE, ma "il banner c'e'" si chiede all'orchestratore.
       Qui prima si guardavano misure e display di .cc-bar. Non basta: l'app del consenso non
       nasconde la barra quando il visitatore ha scelto, la fa scorrere sotto la finestra con
       una translate, e misure e display restano quelli di prima. Risultato misurato in Chrome
       su profilo vergine il 09-09-2026: THE CIRCLE non si apriva MAI sulla prima pagina, nemmeno
       dopo aver accettato i cookie, e il timer restava vivo a vuoto. La regola dei livelli
       (L1 consenso, L2 Fragmenta, L3 popup) sta scritta in un posto solo, snippets/bh-orchestrator.liquid,
       che theme.liquid rende prima di questo file: qui si chiede e basta. Se un layout monta
       THE CIRCLE senza orchestratore la regola se ne va con lui, ed e' voluto: una seconda copia
       del controllo qui dentro divergerebbe in silenzio, che e' peggio.
       Il tetto serve a non tenere un timer vivo all'infinito e a non aprire il popup quattro
       minuti dopo, addosso a chi ha appena cliccato qualcosa. */
    if (layerBlocking()) {
      ccWasBlocked = true;
      var now = Date.now();
      if (!ccDeadline) ccDeadline = now + CC_WAIT_MAX;
      if (now >= ccDeadline) return;
      if (!ccTimer) ccTimer = setTimeout(function () { ccTimer = null; open(atStep); }, CC_STEP);
      return;
    }
    if (ccWasBlocked && !ccBeatDone) {
      /* il banner se n'e' appena andato: un respiro, cosi' il popup non arriva addosso al clic */
      ccBeatDone = true;
      preload();
      if (!ccTimer) ccTimer = setTimeout(function () { ccTimer = null; open(atStep); }, CC_BEAT);
      return;
    }
    if (ccTimer) { clearTimeout(ccTimer); ccTimer = null; }

    /* Mai su un pannello nero. Col precarico di 3,5 s la prima tavola e' gia' complete e qui non
       si aspetta niente (apertura e prima foto nello stesso istante). Se la rete e' lenta la si
       aspetta, al massimo 2 s: poi il popup si apre comunque e la tavola compare appena arriva. */
    preload();
    if (!firstWaited && pics.length) {
      var f0 = loadPic(0);
      if (f0 && !f0.complete) {
        firstWaited = true;
        var go = function () { if (go.d) return; go.d = true; open(atStep); };
        f0.addEventListener('load', go, { once: true });
        f0.addEventListener('error', go, { once: true });
        setTimeout(go, 2000);
        return;
      }
    }

    opened = true;
    lastFocus = document.activeElement;
    root.setAttribute('aria-hidden', 'false');
    if (atStep === 2 || atStep === 3) {
      steps[1].setAttribute('hidden', '');
      steps[atStep].removeAttribute('hidden');
      steps[atStep].classList.add('is-entered');
      current = atStep;
      setCount(S2 && atStep === 2 ? 'II / II' : '');
      if (atStep === 3) setTimeout(function () { close('sub'); }, 7000);
    } else {
      setCount(S2 ? 'I / II' : '');
    }
    root.classList.add('is-open');
    lockScroll(true);
    startShow();
    fitVV();
    setTimeout(function () {
      try {
        /* Su desktop il fuoco va nel campo e si puo' scrivere subito. Su telefono
           no: aprirebbe la tastiera addosso al popup prima ancora che la persona
           abbia letto. Li' il fuoco entra nel pannello, e la tastiera arriva
           quando la persona tocca il campo, cioe' quando l'ha deciso lei. */
        if (window.innerWidth >= 768) (current === 2 ? phone : email).focus({ preventScroll: true });
        else panel.focus({ preventScroll: true });
      } catch (e) {}
    }, REDUCED ? 100 : 700);
    document.addEventListener('keydown', onKey);
  }

  function close(reason) {
    if (!opened || closing) return;
    closing = true;
    if (reason) remember(reason);
    root.classList.remove('is-open');
    root.classList.add('is-closing');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () {
      root.classList.remove('is-closing');
      root.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      stopShow();
      closing = false;
      try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }, 300);
  }

  function setCount(t) {
    if (!count) return;
    if (!t) { count.classList.remove('is-on'); return; }
    count.textContent = t;
    count.classList.add('is-on');
  }

  /* ---------- tastiera: ESC chiude, TAB resta dentro ---------- */
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close('dis'); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])'), function (el) {
      return el.offsetParent !== null && !el.closest('[hidden]');
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- passaggio fra i tempi: le parole cambiano, l'oggetto resta ---------- */
  function goTo(n) {
    var from = steps[current], to = steps[n];
    if (!to || from === to) return;
    current = n;
    setCount(S2 && n === 2 ? 'II / II' : '');
    from.classList.add('is-leaving');
    setTimeout(function () {
      from.setAttribute('hidden', '');
      from.classList.remove('is-leaving');
      to.classList.add('is-entering');
      to.removeAttribute('hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          to.classList.remove('is-entering');
          to.classList.add('is-entered');
        });
      });
      /* il fuoco segue, dopo che il nuovo tempo si e' posato */
      setTimeout(function () {
        try {
          if (n === 2 && phone) phone.focus({ preventScroll: true });
          else if (n === 3) to.focus({ preventScroll: true });
        } catch (e) {}
      }, REDUCED ? 60 : 480);
    }, REDUCED ? 200 : 260);
  }

  /* ---------- le tavole: dissolvenza incrociata, caricate poco prima dell'apertura ----------
     La nuova si accende SOPRA la vecchia (.is-active sopra .is-prev), che resta opaca finche'
     la nuova non e' piena: niente meta' e meta', niente fondo che traspare. Si passa alla
     successiva solo quando e' ARRIVATA (load), mai prima: nessun riquadro vuoto in dissolvenza. */
  var FIRST_MS = 3500;       /* primo cambio, dall'apertura */
  var SLIDE_MS = 5000;       /* poi uno ogni 5 s (la dissolvenza, 1,2 s, e' nel CSS) */
  var PRELOAD_LEAD = 3500;   /* le prime due tavole si scaricano cosi' tanto prima dell'apertura */
  var shown = -1, slideTimer = null, slideOn = false, bad = {}, preloaded = false, firstWaited = false;

  /* Precarico mirato: la prima e poi la seconda, solo quando il popup sta per aprirsi, mai a pagina
     fredda. Col banner del consenso a schermo non parte: il popup non e' piu' atteso a breve, e
     riparte da open() quando il banner se ne va. Riduci movimento: solo la prima. */
  function preload() {
    if (preloaded || !pics.length) return;
    if (layerBlocking()) return;
    preloaded = true;
    var a = loadPic(0);
    if (REDUCED || pics.length < 2) return;
    arrived(a, function () { loadPic(1); });
  }

  function loadPic(i) {
    var p = pics[i];
    if (!p) return null;
    var img = p.querySelector('img[data-src]');
    if (!img) return p.querySelector('img');
    if (!img.getAttribute('src')) {
      var ss = img.getAttribute('data-srcset');
      if (ss) img.setAttribute('srcset', ss);
      img.setAttribute('src', img.getAttribute('data-src'));
    }
    return img;
  }
  function arrived(img, cb) {
    if (!img) { cb(false); return; }
    if (img.complete) { cb(!!img.naturalWidth); return; }
    var done = false;
    function fin(ok) { if (done) return; done = true; cb(ok); }
    img.addEventListener('load', function () { fin(true); }, { once: true });
    img.addEventListener('error', function () { fin(false); }, { once: true });
  }
  function nextIndex() {
    for (var k = 1; k <= pics.length; k++) {
      var n = (shown + k) % pics.length;
      if (!bad[n]) return n;
    }
    return -1;
  }
  function show(i) {
    var prev = root.querySelector('.bhc__pic.is-prev');
    var cur = root.querySelector('.bhc__pic.is-active');
    if (prev) prev.classList.remove('is-prev');
    if (cur) { cur.classList.remove('is-active'); cur.classList.add('is-prev'); }
    Array.prototype.forEach.call(pics, function (p) { p.classList.remove('is-first', 'is-instant'); });
    pics[i].classList.add('is-active');
    shown = i;
  }
  function warmNext() {
    var n = nextIndex();
    if (n > -1 && n !== shown) loadPic(n);
  }
  function schedule(ms) {
    if (!slideOn || slideTimer) return;
    slideTimer = setTimeout(function () { slideTimer = null; step(); }, ms || SLIDE_MS);
  }
  function step() {
    if (!slideOn) return;
    if (document.hidden) { schedule(); return; }
    var n = nextIndex();
    if (n < 0 || n === shown) return;
    arrived(loadPic(n), function (ok) {
      if (!slideOn) return;
      if (!ok) { bad[n] = true; step(); return; }
      show(n);
      warmNext();
      schedule();
    });
  }
  function startShow() {
    if (!pics.length || slideOn) return;
    slideOn = true;
    function first(i) {
      var im = loadPic(i);
      /* gia' arrivata (precarico): visibile nello stesso istante dell'apertura, senza dissolvenza.
         Arrivata dopo (rete lenta): compare appena arriva, con una dissolvenza breve. */
      var ready = !!(im && im.complete && im.naturalWidth);
      arrived(im, function (ok) {
        if (!slideOn) return;
        if (!ok) {
          bad[i] = true;
          var n = i + 1;
          if (n < pics.length) first(n);
          return;
        }
        show(i);
        pics[i].classList.add(ready ? 'is-instant' : 'is-first');
        /* riduci movimento, o una tavola sola: resta quella, ferma */
        if (REDUCED || pics.length < 2) return;
        warmNext();
        schedule(FIRST_MS);
      });
    }
    first(0);
  }
  function stopShow() {
    slideOn = false;
    if (slideTimer) { clearTimeout(slideTimer); slideTimer = null; }
  }

  /* ---------- tastiera su telefono ----------
     La tastiera ruba altezza al viewport VISIBILE ma non a quello di layout: il foglio, ancorato
     in basso, finirebbe sotto le dita. Lo si porta sulla parte visibile e basta (is-kb); l'altezza
     del foglio resta quella del contenuto, non si fissa mai. Con lo zoom a pizzico visualViewport
     si restringe pure: scale > 1 non e' una tastiera. */
  var vv = window.visualViewport;
  function fitVV() {
    if (!vv || !opened) return;
    var kb = window.innerWidth < 768 && vv.scale <= 1.01 && (window.innerHeight - vv.height) > 90;
    root.classList.toggle('is-kb', kb);
    if (kb) {
      root.style.setProperty('--bhc-top', vv.offsetTop + 'px');
      root.style.setProperty('--bhc-h', vv.height + 'px');
    } else {
      root.style.removeProperty('--bhc-top');
      root.style.removeProperty('--bhc-h');
    }
  }
  if (vv) { vv.addEventListener('resize', fitVV); vv.addEventListener('scroll', fitVV); }

  /* la conferma atterra in silenzio: dissolvenza, poi 400ms di niente */
  function finish() {
    goTo(3);
    /* la conferma porta un link: sette secondi, non cinque, o si chiude
       mentre la persona lo sta ancora leggendo */
    setTimeout(function () { close('sub'); }, 7000);
  }

  /* ---------- messaggi ---------- */
  function say(el, msg, input) {
    if (!el) return;
    el.textContent = msg || '';
    el.classList.toggle('is-on', !!msg);
    if (input) input.classList.toggle('is-bad', !!msg);
  }

  /* ---------- STEP 1: Shopify ----------
     Invio NATIVO, non fetch. Provato il 28-08-2026: il negozio ha la
     protezione antispam di Shopify attiva, il form customer porta un campo
     h-captcha-response che solo lo script di Shopify sa riempire, e una
     fetch riceve 400 "Missing CAPTCHA token". Quindi si lascia fare a
     Shopify: captcha invisibile, POST, redirect a return_to con
     customer_posted=true, e al ritorno il popup riapre al tempo successivo.
     L'unica validazione che resta qui e' quella dell'email, prima di partire. */
  if (form1) {
    form1.addEventListener('submit', function (e) {
      say(err1, '', email);
      var v = (email.value || '').trim();
      if (!v || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        e.preventDefault();
        say(err1, MSG.email, email);
        email.focus();
        return;
      }
      try { sessionStorage.setItem('bh_circle_step1', '1'); } catch (x) {}
      /* NON disabled: lo script antispam di Shopify ferma questo submit, chiede il
         token al captcha e poi rilancia l'invio; un bottone disabilitato potrebbe
         inghiottire quel rilancio. Solo un velo, via CSS. */
      btn1.classList.add('is-busy');
      /* nessun preventDefault: parte l'invio nativo con il captcha di Shopify */
    });
  }

  /* ---------- STEP 2: Klaviyo, chiave pubblica ---------- */
  function e164() {
    var raw = (phone.value || '').replace(/[\s().-]/g, '');
    var prefix = cc ? cc.value : '+39';
    if (raw.charAt(0) === '+') return raw;
    if (raw.indexOf('00') === 0) return '+' + raw.slice(2);
    /* il trunk 0 cade quasi ovunque; l'Italia lo tiene sui fissi e non lo usa sui mobili */
    if (raw.charAt(0) === '0' && prefix !== '+39') raw = raw.slice(1);
    return prefix + raw;
  }

  if (form2) {
    form2.addEventListener('submit', function (e) {
      e.preventDefault();
      say(err2, '', phone);
      var num = e164();
      if (!/^\+[1-9]\d{6,14}$/.test(num)) { say(err2, MSG.phone, phone); phone.focus(); return; }
      if (!COMPANY || !LIST_WA) { say(err2, MSG.net, null); return; }
      var mail = (email && email.value || '').trim();
      var props = { circle_channel: CHANNEL, circle_consent_text: CONSENT_TEXT, circle_consent_ts: new Date().toISOString() };
      var d = bdayD && bdayD.value, m = bdayM && bdayM.value;
      if (d && m) {
        props.circle_birthday_md = m + '-' + d;
        /* giorno e mese soltanto: l'anno 1904 e' un segnaposto tecnico (bisestile,
           regge il 29 febbraio) per la proprieta' data che Klaviyo usa nei flow annuali */
        props.Birthday = '1904-' + m + '-' + d;
      }
      /* DUE chiamate, apposta. Sondato sull'account il 28-08-2026: se la
         chiamata di consenso porta anche l'email, Klaviyo registra un consenso
         EMAIL sulla lista del numero, cioe' riusa la base che questo step non
         deve toccare. Quindi: (A) /client/profiles aggancia numero e compleanno
         al profilo dell'email, senza consensi; (B) /client/subscriptions porta
         il SOLO numero e il consenso del canale di messaggistica. */
      var subs = {};
      subs[CHANNEL] = { marketing: { consent: 'SUBSCRIBED' } };
      var H = { 'Content-Type': 'application/json', 'revision': '2026-07-15' };
      var base = 'https://a.klaviyo.com/client/';
      var q = '?company_id=' + encodeURIComponent(COMPANY);
      var profAttrs = { phone_number: num, properties: props };
      if (mail) profAttrs.email = mail;
      btn2.disabled = true;
      fetch(base + 'profiles/' + q, { method: 'POST', headers: H, body: JSON.stringify({ data: { type: 'profile', attributes: profAttrs } }) })
        .then(function (ra) {
          if (!(ra.status === 202 || ra.status === 200)) throw new Error('profile');
          return fetch(base + 'subscriptions/' + q, {
            method: 'POST', headers: H,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: { custom_source: 'the-circle-popup-phone', profile: { data: { type: 'profile', attributes: { phone_number: num, subscriptions: subs } } } },
                relationships: { list: { data: { type: 'list', id: LIST_WA } } }
              }
            })
          });
        })
        .then(function (r) {
          btn2.disabled = false;
          if (r.status === 202 || r.status === 200 || r.status === 409) { finish(); return; }
          if (r.status === 400) {
            /* un 400 e' quasi sempre il numero; ma se il canale non e' attivo
               sull'account ("WhatsApp is not enabled") la colpa non e' del
               visitatore, e non gli si dice che il suo numero e' sbagliato */
            return r.text().then(function (t) {
              say(err2, /not enabled/i.test(t || '') ? MSG.net : MSG.phone, phone);
            });
          }
          say(err2, MSG.net, null);
        })
        .catch(function () { btn2.disabled = false; say(err2, MSG.net, null); });
    });
  }

  /* ---------- chiusure ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-bhc-close]'), function (b) {
    b.addEventListener('click', function () { close(current === 1 ? 'dis' : 'sub'); });
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-bhc-dismiss]'), function (b) {
    b.addEventListener('click', function () { close('dis'); });
  });
  var skip2 = root.querySelector('[data-bhc-skip2]');
  if (skip2) skip2.addEventListener('click', function () { finish(); });
  root.addEventListener('click', function (e) { if (e.target === root) close(current === 1 ? 'dis' : 'sub'); });

  /* ---------- ritorno dal captcha ---------- */
  var pending = false;
  try {
    if (location.search.indexOf('customer_posted=true') > -1 && sessionStorage.getItem('bh_circle_step1') === '1') {
      sessionStorage.removeItem('bh_circle_step1');
      pending = true;
    }
  } catch (e) {}
  if (pending) {
    remember('sub');
    preload();
    setTimeout(function () { open(S2 ? 2 : 3); }, 400);
    return;
  }

  /* ---------- inneschi ---------- */
  if (suppressed()) return;

  var t0 = Date.now();
  var timer = setTimeout(function () { open(1); }, DELAY);
  /* il precarico parte PRELOAD_LEAD prima del timer d'apertura (mai prima di 1 s, e mai col banner a schermo) */
  setTimeout(preload, Math.max(1000, DELAY - PRELOAD_LEAD));

  function onScroll() {
    var h = document.documentElement;
    var depth = (window.scrollY + window.innerHeight) / Math.max(1, h.scrollHeight);
    if (depth >= SCROLL - 0.15) preload();
    if (depth >= SCROLL && Date.now() - t0 >= 3000) {
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      open(1);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
